import React, { useMemo } from 'react';
import './Field.css';

function Icon({ name }) {
  const common = { width: 18, height: 18, viewBox: '0 0 24 24', 'aria-hidden': true, focusable: false };
  switch (name) {
    case 'email':
      return (
        <svg {...common}>
          <path d="M4 6h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="none" stroke="currentColor" strokeWidth="1.75"/>
          <path d="M22 8l-10 6L2 8" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round"/>
        </svg>
      );
    case 'phone':
      return (
        <svg {...common}>
          <rect x="7" y="2" width="10" height="20" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.75"/>
          <circle cx="12" cy="18" r="1" fill="currentColor"/>
        </svg>
      );
    case 'lock':
      return (
        <svg {...common}>
          <rect x="4" y="10" width="16" height="10" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.75"/>
          <path d="M8 10V7a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" strokeWidth="1.75"/>
        </svg>
      );
    case 'user':
      return (
        <svg {...common}>
          <circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="1.75"/>
          <path d="M4 20c0-4 4-6 8-6s8 2 8 6" fill="none" stroke="currentColor" strokeWidth="1.75"/>
        </svg>
      );
    default:
      return null;
  }
}

export default function Field({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  icon,
  valid = undefined,
  showStatus = true,
  withEye = false,
  showPassword = false,
  onToggleShow = () => {},
  name,
  inputMode,
  autoComplete,
  maxLength,
}) {
  const show = showStatus && typeof value === 'string' && value.trim().length > 0;
  const cls = useMemo(() => {
    const base = ['input'];
    if (show && valid !== undefined) base.push(valid ? 'valid' : 'invalid');
    return base.join(' ');
  }, [show, valid]);

  return (
    <label>
      <span>{label}</span>
      <div className="input-group has-icon">
        {icon && (
          <span className="icon" aria-hidden="true"><Icon name={icon} /></span>
        )}
        <input
          name={name}
          className={cls}
          type={withEye ? (showPassword ? 'text' : type) : type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          inputMode={inputMode}
          autoComplete={autoComplete}
          maxLength={maxLength}
        />
        {show && valid !== undefined && (
          <span className={`status ${withEye ? 'with-eye ' : ''}${valid ? 'ok' : 'no'} show`} aria-hidden="true">
            {valid ? (
              <svg viewBox="0 0 24 24" width="18" height="18"><path d="M4 12l5 5 11-11" fill="none" stroke="currentColor" strokeWidth="2"/></svg>
            ) : (
              <svg viewBox="0 0 24 24" width="18" height="18"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2"/></svg>
            )}
          </span>
        )}
        {withEye && (
          <button
            type="button"
            className="btn-eye"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            onClick={onToggleShow}
          >
            {showPassword ? (
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                <path d="M2 2l20 20" stroke="currentColor" strokeWidth="1.75"/>
                <path d="M3 12s4-6 9-6 9 6 9 6-4 6-9 6-9-6-9-6z" fill="none" stroke="currentColor" strokeWidth="1.75"/>
                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.75"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                <path d="M3 12s4-6 9-6 9 6 9 6-4 6-9 6-9-6-9-6z" fill="none" stroke="currentColor" strokeWidth="1.75"/>
                <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.75"/>
              </svg>
            )}
          </button>
        )}
      </div>
    </label>
  );
}
